(ns manage.adset-decision-tree-page.ad-variant-table-ocp.cm360-settings
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [common.form :as form]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.cm360-settings :as cm360.q]
            [manage.adset-decision-tree-page.view.common :refer [async-id-input]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- ->form-values [cm360-settings initial-enabled]
  (let [{:keys [enabled campaign-id site-id]} (->clj cm360-settings)]
    #js {:enabled (if (some? initial-enabled) initial-enabled (boolean enabled))
         :campaign-id (or campaign-id "")
         :site-id (or site-id "")}))

(defui settings-modal [{:keys [initial-enabled]}]
  (let [url-context (use-subscribe [:url-context])
        {cm360-settings :data} (use-query (cm360.q/cm360-settings-query url-context))
        {:keys [handleSubmit control]} (form/use-form #js {:values (->form-values cm360-settings initial-enabled)})
        {save-cm360-settings :mutate} (use-mutation (cm360.q/cm360-settings-mutation url-context))
        on-submit (handleSubmit
                   (fn [form-data]
                     (let [{:keys [enabled campaign-id site-id]} (->clj form-data)]
                       (save-cm360-settings {:enabled (boolean enabled)
                                             :campaign-id campaign-id
                                             :site-id site-id})
                       (rf/dispatch [:modal/close]))))]
    ($ modal-v2
       {:title "CM360 settings"
        :footer ($ Stack {:direction "row" :spacing 1 :justifyContent "flex-end"}
                   ($ Button {:variant "outlined"
                              :onClick #(rf/dispatch [:modal/close])}
                      "Cancel")
                   ($ Button {:variant "contained"
                              :onClick on-submit}
                      "Save"))}
       ($ Stack {:spacing 2}
          ($ Alert {:severity "info"}
             "In CM360 mode trackers are generated automatically. "
             "It's not possible to define manual trackers, tagging or pixels.")
          ($ async-id-input {:name "campaign-id"
                             :label "CM360 campaign"
                             :placeholder "Select your campaign"
                             :required true
                             :rules #js {:required "Required"}
                             :control control
                             :query (cm360.q/cm360-campaigns-query url-context)})
          ($ async-id-input {:name "site-id"
                             :label "CM360 Site"
                             :placeholder "Select your site"
                             :required true
                             :rules #js {:required "Required"}
                             :control control
                             :query (cm360.q/cm360-sites-query url-context)})
          ($ form/switch {:label "Enable CM360 tracker generation"
                          :name "enabled"
                          :control control})))))

(defmodal cm360-settings-modal ::cm360-settings {:max-width "xs"} [props]
  ($ settings-modal props))

(defui disable-confirmation [{:keys [on-confirm]}]
  ($ modal-v2
     {:title "Disable CM360 mode"
      :footer ($ Stack {:direction "row" :spacing 1 :justifyContent "flex-end"}
                 ($ Button {:variant "outlined"
                            :onClick #(rf/dispatch [:modal/close])}
                    "Cancel")
                 ($ Button {:variant "contained"
                            :color "warning"
                            :onClick (fn [] (rf/dispatch [:modal/close]) (on-confirm))}
                    "Disable"))}
     ($ Typography {:sx #js {:maxWidth 600}}
        "Disabling CM360 mode will stop automatic tracker generation after publishing. "
        "The CM360 placements you defined will no longer be used. Are you sure?")))

(defmodal disable-confirmation-modal ::disable-confirmation [props]
  ($ disable-confirmation props))
